import React from 'react';

import MemberDetailsCard from './MemberDetailsCard';
import CustomerDetailsCard from './CustomerDetailsCard';
import HistoryLogCreatedInfo from './HistoryLogCreatedInfo';
import WorkerDetailsCard from './WorkerDetailsCard';
import AssignmentDetailsCard from './AssignmentDetailsCard';
import BaseCollapse from 'components/wrappers/BaseCollapse';
import { HistoryResponseModel, HistoryTypeEnum } from 'api/adminApiClient';
import { ActivitiesSectionPageTypeEnum } from 'components/ActivitiesDetailsSection/enums';
import AssignmentTerminationDetailsInfo from './AssignmentTerminationDetailsInfo';
import CustomerCascadeFeeUpdateDetailsInfo from './CustomerCascadeFeeUpdateDetailsInfo';

import styles from './HistoryCard.module.less';

type Props = {
  entityId: string;
  historyItem: HistoryResponseModel;
  pageType: ActivitiesSectionPageTypeEnum;
};

const { Panel } = BaseCollapse;

export default function HistoryCard(props: Props) {
  const { historyItem, pageType, entityId } = props;
  const { id, type } = historyItem;
  const historyLogPanelKey = `history-log-${id}`;

  const renderDetailsCard = () => {
    switch (pageType) {
      case ActivitiesSectionPageTypeEnum.Customer:
        if (type === HistoryTypeEnum.CustomerAssignmentFeeCascadeUpdateTotalDetails) {
          return <CustomerCascadeFeeUpdateDetailsInfo historyItem={historyItem} />;
        }

        return (
          <CustomerDetailsCard
            customerId={entityId}
            historyItem={historyItem}
          />
        );

      case ActivitiesSectionPageTypeEnum.Member:
        return (
          <MemberDetailsCard userId={entityId} historyItem={historyItem} />
        );

      case ActivitiesSectionPageTypeEnum.Assignment:
        return type === HistoryTypeEnum.RescindingTermination ? (
          <AssignmentTerminationDetailsInfo historyItem={historyItem} />
        ) : (
          <AssignmentDetailsCard historyItem={historyItem} />
        );

      case ActivitiesSectionPageTypeEnum.Worker:
      default:
        return (
          <WorkerDetailsCard workerId={entityId} historyItem={historyItem} />
        );
    }
  };

  const renderHistoryCard = () => {
    switch (type) {
      case HistoryTypeEnum.Details:
      case HistoryTypeEnum.RescindingTermination:
      case HistoryTypeEnum.CustomerAssignmentFeeCascadeUpdateTotalDetails:
        return (
          <BaseCollapse
            defaultActiveKey={historyLogPanelKey}
            className={styles.card}
          >
            <Panel
              key={historyLogPanelKey}
              header={
                <HistoryLogCreatedInfo
                  className={styles.cardHeadCollapse}
                  historyItem={historyItem}
                  pageType={pageType}
                />
              }
            >
              {renderDetailsCard()}
            </Panel>
          </BaseCollapse>
        );

      case HistoryTypeEnum.Stage:
      case HistoryTypeEnum.Scheduler:
      case HistoryTypeEnum.Integration:
      case HistoryTypeEnum.Termination:
      case HistoryTypeEnum.CustomerAgreement:
      case HistoryTypeEnum.RenewalRehire:
      case HistoryTypeEnum.CustomerAssignmentFeeCascadeUpdate:
      case HistoryTypeEnum.CustomerAssignmentFeeUpdateOnlyNew:
        return (
          <div className={styles.card}>
            <HistoryLogCreatedInfo
              historyItem={historyItem}
              pageType={pageType}
            />
          </div>
        );
    }
  };

  return <>{renderHistoryCard()}</>;
}
